export default {"src":"/_next/static/media/bankDivider.6ee30443.svg","height":20,"width":1,"blurWidth":0,"blurHeight":0};